import { component, computed } from 'knockout-decorators'
import { TouristTaxState } from '../../state/tourist-tax'

import source from './template.html?raw'
import './style.css'
import { Language } from '~/utils/language'

@component('tourist-tax-form', source)
export class TouristTaxForm {
  private touristTaxState = TouristTaxState.get()

  @computed
  public get totalTouristTaxTime() {
    return this.touristTaxState.cartResponse?.expiry || 8 * 60 * 1000
  }

  public get content() {
    return this.touristTaxState.content
  }

  public get touristTaxAmount() {
    return this.touristTaxState.touristTaxAmount
  }

  public get touristTaxCurrency() {
    return this.touristTaxState.touristTaxCurrency
  }

  public get totalGuests() {
    return this.touristTaxState.getTotalGuests()
  }

  public get totalTouristTax() {
    return this.touristTaxState.getTotalTouristTax
  }

  public get touristTaxPriceFormatted() {
    return Language.formatCurrency(
      this.touristTaxAmount,
      this.touristTaxCurrency
    )
  }

  public get totalTouristTaxFormatted() {
    return Language.formatCurrency(
      this.totalTouristTax,
      this.touristTaxCurrency
    )
  }

  public get remainingTouristTaxTime() {
    return this.touristTaxState.remainingTouristTaxTime
  }

  @computed
  public get remainingTouristTaxTimeFormatted() {
    const totalSeconds = Math.max(
      0,
      Math.floor(this.remainingTouristTaxTime / 1000)
    )
    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    return `${minutes}:${seconds.toString().padStart(2, '0')}`
  }

  @computed
  public get remainingTouristTaxProgressOffset() {
    const radius = 54
    const circumference = 2 * Math.PI * radius
    const progress = Math.max(
      0,
      Math.min(1, this.remainingTouristTaxTime / this.totalTouristTaxTime)
    )
    return circumference * (1 - progress)
  }

  @computed
  public get timerColor() {
    const oneMinute = 60 * 1000
    const halfTime = this.totalTouristTaxTime / 2

    if (this.remainingTouristTaxTime <= oneMinute) {
      return '#e28377'
    }
    if (this.remainingTouristTaxTime <= halfTime) {
      return '#f4c430'
    }
    return '#39b586'
  }

  public async cancel() {
    await this.touristTaxState.hideTouristTaxFormModal()
  }
}
